import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modale-conferma-azione',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-card">
      <div class="modal-icon modal-icon-warning">
         <i class="bi bi-exclamation-triangle"></i>
      </div>
      <div class="modal-title">{{ title || 'Conferma' }}</div>
      <div class="modal-subtitle">{{ message || 'Sei sicuro di voler procedere?' }}</div>
      
      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary w-100" (click)="activeModal.close(false)">Annulla</button>
        <button class="btn btn-kf-primary w-100" ngbAutofocus (click)="activeModal.close(true)">Conferma</button>
      </div>
    </div>
  `
})
export class ModaleConfermaAzioneComponent {
  activeModal = inject(NgbActiveModal);
  @Input() title = '';
  @Input() message = '';
}
